import { Link, useLocation, Outlet } from 'react-router';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTrigger
} from '@/components/ui/sidebar';
import { menuItems } from '@/config/menu.config';
import { SidebarUserMenu } from './sidebar-user-menu';

export function AppShell() {
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <SidebarProvider defaultOpen={false}>
      <Sidebar collapsible='icon'>
        <SidebarHeader>
          {/* Same spot open or closed, so the width animates and the name just clips and fades. */}
          <Link to='/accounts' className='flex items-center gap-2 overflow-hidden px-0.5'>
            <img src='/assets/brand/kim-ai-logo.svg' className='size-8 shrink-0' alt='Kim' />
            <span className='whitespace-nowrap text-[15px] font-semibold leading-5 text-ink transition-opacity duration-200 group-data-[collapsible=icon]:opacity-0'>Control Panel</span>
          </Link>
        </SidebarHeader>
        <SidebarContent>
          <SidebarMenu>
            {menuItems.map((item) => (
              <SidebarMenuItem key={item.path}>
                <SidebarMenuButton
                  asChild
                  // The collapsed padding open too, so icons don't jump as the sidebar animates.
                  className='px-[5px]'
                  tooltip={item.label}
                  isActive={isActive(item.path)}
                >
                  <Link to={item.path}>
                    <item.icon />
                    <span>{item.label}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarContent>
        <SidebarFooter className='px-0 pb-3'>
          {/* The open/close toggle lives here now that the page has no top bar (⌘B still works). */}
          <SidebarTrigger className='ml-1 text-gray-800' />
          <SidebarUserMenu />
        </SidebarFooter>
      </Sidebar>
      {/* min-w-0 lets wide content (tables) scroll inside the page instead of widening it. */}
      <SidebarInset className='min-w-0'>
        <div className='flex flex-1 flex-col overflow-auto'>
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
